import React from 'react';

const Packages = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="bg-white p-8 rounded-lg shadow text-center">
      <h1 className="text-2xl font-bold mb-2">Packages</h1>
      <p className="text-gray-600">This is the Packages page. Content coming soon!</p>
    </div>
  </div>
);

export default Packages; 